/**
* @ngdoc service
* @name WcResponsiveTableModule.service:WcColumnFilterService
* @description
* The wcColumnFilterService service filters the column names of the datatable on key press.
*/



angular.module('WcResponsiveTableModule')
	.factory('WcColumnFilterService',['_', function (_) {
		function WcColumnFilterService() {
			this.columnsToFilter = [];
		}

		/**
		 * @ngdoc method
		 * @name WcColumnFilterService.getColumnsToFilter
		 * @methodOf WcResponsiveTableModule.service:WcColumnFilterService
		 * @returns {string} This string holds the list of columns to be filtered
		 * @description
		 * The method returns the columns that needs to be filtered
		 */

		WcColumnFilterService.prototype.getColumnsToFilter = function () {
			return this.columnsToFilter;
		};

		/**
		 * @ngdoc method
		 * @name WcColumnFilterService.setColumnsToFilter
		 * @methodOf WcResponsiveTableModule.service:WcColumnFilterService
		 * @param {integer} key This integer value holds the index of the array
		 * @param {string} value This string value holds the value of the array
         * @param {boolean} mathFilter This boolean tells whether this filter is intended as a conditional math filter
		 * @description
		 * The method set the columns to the array
		 */

		WcColumnFilterService.prototype.setColumnsToFilter = function (key, value, mathFilter) {
			//this.columnsToFilter[key] = [value, mathFilter];
			var index = _.findIndex(this.columnsToFilter, ['predicate', key]);
			if(index == -1) {
                this.columnsToFilter.push({
                    predicate: key,
                    value: value,
                    isMathFilter: mathFilter
                });
            } else {
				this.columnsToFilter[index].value = value;
				this.columnsToFilter[index].isMathFilter = mathFilter;
			}
		};

        /**
         * @ngdoc method
         * @name WcColumnFilterService.removeColumnToFilter
         * @methodOf WcResponsiveTableModule.service:WcColumnFilterService
         * @param {string} key This string value holds the key for the column to remove from the filtering
         * @description
         * Removes a filter based on the key that is passed in.
         */
		WcColumnFilterService.prototype.removeColumnToFilter = function (key){
			var index = _.findIndex(this.columnsToFilter, ['predicate', key]);
			if(index != -1){
				this.columnsToFilter.splice(index, 1);
			}
		};

        /**
         * @ngdoc method
         * @name WcColumnFilterService.getBlankFilters
         * @methodOf WcResponsiveTableModule.service:WcColumnFilterService
         * @description
         * Removes all filters that have an empty string value
         */
		WcColumnFilterService.prototype.getBlankFilters = function () {
			var blankFilters = [];
			for(var i = this.columnsToFilter.length-1; i >= 0; i--){
				if(this.columnsToFilter[i].value === ""){
                    blankFilters.push(this.columnsToFilter[i]);
				}
			}
			return blankFilters;
        };

		return WcColumnFilterService;
	}]);